
// import React from "react";

// const InfoContent = () => {
//   return (
//     <section className="space-y-10 text-gray-800 text-base leading-loose text-justify">
//       <div className="space-y-3 border-b pb-4">
//         <p>
//           <strong>İstanbul Temizlik Servisi</strong> olarak, halı, koltuk ve stor/zebra temizleme hizmetlerinde 
//           <strong> kaliteli, güvenli ve hijyenik</strong> çözümler sunuyoruz. 
//           Halılarınız özel <strong>antibakteriyel şampuanlarla</strong> ve 
//           <strong> profesyonel makinelerde</strong> temizlenir. Ürünlerinize zarar vermeyen 
//           özel bakım yöntemleriyle hijyenik bir şekilde teslim edilir.
//         </p>
//       </div>

//       <div className="space-y-2 border-b pb-4">
//         <h3 className="font-semibold text-lg text-[#00704A]">İstanbul Temizlik Servisi – Hijyenin Yeni Hali.</h3>
//         <ul className="list-disc list-inside space-y-1">
//           <li><strong>Deneyimli ekip</strong> ve modern makinelerle derinlemesine temizlik.</li>
//           <li><strong>Organik ürünlerle</strong> çevre dostu temizlik.</li>
//           <li>Stor, zebra, yorgan, battaniye ve perde gibi ev tekstil ürünleri özenle yıkanır.</li>
//           <li><strong>Ücretsiz servis</strong> ile adresten alım ve teslimat.</li>
//           <li>Ürünleriniz <strong>steril ambalajla</strong> teslim edilir.</li>
//         </ul>
//       </div>

//       <div className="space-y-2 border-b pb-4">
//         <h3 className="font-semibold text-lg text-[#00704A]">Neden İstanbul Temizlik Servisi?</h3>
//         <ul className="list-disc list-inside space-y-1">
//           <li>Kapıdan alım ve teslimat ile <strong>ücretsiz servis</strong>.</li>
//           <li><strong>Hijyenik ortamda</strong> profesyonel temizlik.</li>
//           <li>Antibakteriyel ürün ve ekipman kullanımı.</li>
//           <li><strong>Uzman personel</strong> ve gelişmiş yıkama sistemleri.</li>
//         </ul>
//       </div>

//       <div className="space-y-2 border-b pb-4">
//         <h3 className="font-semibold text-lg text-[#00704A]">Biz Kimiz ve Size Nasıl Yardımcı Oluyoruz?</h3>
//         <ul className="list-disc list-inside space-y-1">
//           <li>Profesyonel temizlikte <strong>çözüm ortağınız</strong>.</li>
//           <li>Halı dışında <strong>koltuk, yorgan, zebra ve stor perde</strong> yıkama hizmeti sunuyoruz.</li>
//           <li>Yaşam alanlarınıza <strong>hijyen, ferahlık ve konfor</strong> getiriyoruz.</li>
//         </ul>
//       </div>

//       <div className="space-y-2 border-b pb-4">
//         <h3 className="font-semibold text-lg text-[#00704A]">Neden Bizi Tercih Etmelisiniz?</h3>
//         <ul className="list-disc list-inside space-y-1">
//           <li><strong>Gelişmiş sistemler</strong> ile etkili ve hızlı temizlik.</li>
//           <li><strong>%100 müşteri memnuniyeti</strong> garantisi.</li>
//           <li>Uygun fiyat politikası ve kampanyalı hizmetler.</li>
//           <li><strong>Zamanında teslimat</strong> ve kaliteli işçilik.</li>
//         </ul>
//       </div>

//       <div className="space-y-2">
//         <h3 className="font-semibold text-lg text-[#00704A]">Ek Avantajlar:</h3>
//         <ul className="list-disc list-inside space-y-1">
//           <li><strong>Ücretsiz servis</strong> hizmeti tüm İstanbul geneline sunulur.</li>
//           <li><strong>Yerinde koltuk ve perde yıkama</strong> imkânı.</li>
//           <li><strong>Güler yüzlü hizmet</strong> ve güvenilir ekip.</li>
//         </ul>
//       </div>
//     </section>
//   );
// };

// export default InfoContent;
import React from "react";
import {
  ShieldCheck,
  Sparkles,
  Truck,
  BadgeCheck,
  Sofa,
  Clock3,
  HeartHandshake,
  Flower2,
} from "lucide-react";

const features = [
  {
    icon: <Sparkles size={20} />,
    title: "Derinlemesine Hijyen",
    desc: "Profesyonel makineler ve antibakteriyel ürünlerle etkili temizlik.",
  },
  {
    icon: <ShieldCheck size={20} />,
    title: "Güvenilir Hizmet",
    desc: "Deneyimli ekip ve güvenli temizlik süreçleriyle kaliteli hizmet.",
  },
  {
    icon: <Truck size={20} />,
    title: "Ücretsiz Servis",
    desc: "Kapıdan ücretsiz alım ve hızlı teslimat avantajı.",
  },
];

const services = [
  "Halı Yıkama",
  "Koltuk Yıkama",
  "Stor & Zebra Perde",
  "Yorgan Yıkama",
  "Battaniye Temizliği",
  "Yerinde Yıkama",
];

const advantages = [
  {
    icon: <BadgeCheck size={18} />,
    text: "%100 müşteri memnuniyeti odaklı hizmet anlayışı",
  },
  {
    icon: <Clock3 size={18} />,
    text: "Zamanında teslimat ve profesyonel süreç yönetimi",
  },
  {
    icon: <Sofa size={18} />,
    text: "Tüm ev tekstili ürünlerine özel bakım uygulamaları",
  },
  {
    icon: <HeartHandshake size={18} />,
    text: "Güler yüzlü destek ve güvenilir ekip hizmeti",
  },
];

const InfoContent = () => {
  return (
    <section className="space-y-8 text-[#2E2A26] leading-relaxed">
      {/* Üst Açıklama */}
      <div className="relative overflow-hidden rounded-[32px] border border-[#E8D9C8] bg-gradient-to-br from-[#FFF9F3] via-[#FDF6EF] to-[#F6EBDD] p-7 shadow-[0_10px_40px_rgba(0,0,0,0.05)]">
        <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#C08B4B]/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-32 w-32 rounded-full bg-[#0E2A47]/5 blur-3xl" />

        <div className="relative z-10 space-y-5">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#D8C2A8] bg-white/80 px-4 py-2 text-xs font-semibold uppercase tracking-[2px] text-[#B07A3F] backdrop-blur-sm">
            <Flower2 size={14} />
            Profesyonel Temizlik Hizmeti
          </span>

          <div className="space-y-4">
            <h2 className="text-3xl md:text-4xl font-black leading-tight text-[#0E2A47]">
              İstanbul Temizlik Servisi ile
              <span className="block text-[#B07A3F]">
                Hijyenin ve Konforun Yeni Hali
              </span>
            </h2>

            <p className="text-[15px] md:text-[16px] leading-8 text-[#5B524B]">
              <strong className="text-[#0E2A47]">
                İstanbul Temizlik Servisi
              </strong>{" "}
              olarak halı, koltuk, zebra perde, yorgan ve battaniye temizliğinde
              profesyonel çözümler sunuyoruz. Özel antibakteriyel şampuanlar,
              modern yıkama sistemleri ve deneyimli ekibimiz sayesinde ürünleriniz
              ilk günkü temizliğine ve ferahlığına kavuşur.
            </p>

            <p className="text-[15px] md:text-[16px] leading-8 text-[#5B524B]">
              Kumaş yapısına zarar vermeyen özel bakım uygulamalarımız sayesinde
              ev tekstili ürünleriniz güvenle temizlenir, hijyenik paketleme ile
              sizlere teslim edilir.
            </p>
          </div>
        </div>
      </div>

      {/* Özellik Kartları */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {features.map((item, index) => (
          <div
            key={index}
            className="group rounded-[26px] border border-[#EADBCB] bg-white p-6 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(0,0,0,0.08)]"
          >
            <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#C18A4A] to-[#D6A76A] text-white shadow-lg">
              {item.icon}
            </div>

            <h3 className="mb-2 text-lg font-bold text-[#0E2A47]">
              {item.title}
            </h3>

            <p className="text-sm leading-7 text-[#655C55]">
              {item.desc}
            </p>
          </div>
        ))}
      </div>

      {/* Hizmet Alanı */}
      <div className="rounded-[30px] border border-[#EADBCB] bg-[#FFFDFB] p-7 shadow-[0_10px_35px_rgba(0,0,0,0.04)]">
        <div className="mb-6 flex items-center justify-between gap-4 flex-wrap">
          <div>
            <h3 className="text-2xl font-black text-[#0E2A47]">
              Hizmet Alanlarımız
            </h3>
            <p className="mt-2 text-sm leading-7 text-[#6A625A]">
              Ev tekstili ürünlerinize özel profesyonel temizlik çözümleri.
            </p>
          </div>

          <div className="h-[2px] w-20 rounded-full bg-gradient-to-r from-[#C18A4A] to-transparent" />
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="rounded-2xl border border-[#EFE2D4] bg-[#FFF8F1] px-4 py-4 text-center text-sm font-semibold text-[#4A433D] transition-all duration-300 hover:border-[#C18A4A] hover:bg-white hover:text-[#0E2A47]"
            >
              {service}
            </div>
          ))}
        </div>
      </div>

      {/* Neden Biz */}
      <div className="rounded-[30px] bg-gradient-to-br from-[#0E2A47] to-[#183A5C] p-8 text-white shadow-[0_12px_45px_rgba(0,0,0,0.12)]">
        <div className="mb-8">
          <span className="text-sm font-semibold uppercase tracking-[3px] text-[#E8C18E]">
            Neden Bizi Tercih Etmelisiniz?
          </span>

          <h3 className="mt-3 text-3xl font-black leading-tight">
            Profesyonel Temizlikte
            <span className="block text-[#E8C18E]">
              Güvenilir Çözüm Ortağınız
            </span>
          </h3>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {advantages.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm"
            >
              <div className="mt-1 flex h-11 w-11 items-center justify-center rounded-xl bg-[#C18A4A] text-white shadow-lg">
                {item.icon}
              </div>

              <p className="text-[15px] leading-7 text-[#F2F2F2]">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Alt Vurgu */}
      <div className="rounded-[30px] border border-[#E7D5C2] bg-gradient-to-r from-[#FFF8F0] to-[#F9F1E8] px-7 py-8 text-center shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
        <h3 className="text-2xl md:text-3xl font-black text-[#0E2A47] leading-tight">
          Temizliğin Adresi,
          <span className="block text-[#B07A3F]">
            İçiniz Rahat Hizmet
          </span>
        </h3>

        <p className="mx-auto mt-4 max-w-3xl text-[15px] leading-8 text-[#655C55]">
          İstanbul genelinde ücretsiz servis, profesyonel ekip ve modern
          temizlik sistemleriyle hizmet veriyoruz. Ürünlerinizi hijyenik,
          güvenilir ve özenli şekilde temizleyerek yaşam alanlarınıza ferahlık
          katıyoruz.
        </p>
      </div>
    </section>
  );
};

export default InfoContent;